"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKGeoThumbnail = exports.boundaryIcon = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var services_1 = require("../../services");
var GeoThumbnailWorker_helpers_1 = require("../../services/GeoThumbnailService/GeoThumbnailWorker.helpers");
require("./GKGeoThumbnail.css");
// eslint-disable-next-line @typescript-eslint/no-var-requires
exports.boundaryIcon = "<svg viewBox=\"0 0 64 58\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m0 0h31.71l32.29 36.06v21.94h-64z\" fill=\"#ccc\"></path></svg>";
var GKGeoThumbnail = /** @class */ (function (_super) {
    __extends(GKGeoThumbnail, _super);
    function GKGeoThumbnail(props) {
        var _this = _super.call(this, props) || this;
        _this.prepareIconResult = null;
        _this.fillClass = _this.props.fill ? "fill-" + _this.props.fill : "";
        _this.mappedProps = __assign({}, (0, common_1.mapDefaultProps)(_this.props, {
            _gkComponentName: "gk-geo-thumbnail",
            className: _this.fillClass,
        }));
        _this.onIconSuccess = function (svg) {
            if (_this.prepareIconResult) {
                // clear out the icon result, it did its thing
                _this.prepareIconResult = null;
                _this.setState({
                    icon: svg,
                    dangerousIconHtml: {
                        __html: svg,
                    },
                });
            }
        };
        _this.onIconError = function () {
            //
        };
        _this.state = {
            icon: null,
            dangerousIconHtml: {
                __html: exports.boundaryIcon,
            },
        };
        return _this;
    }
    GKGeoThumbnail.prototype.getShapeFromCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hash, svg, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        hash = (0, GeoThumbnailWorker_helpers_1.hashShape)(this.props.shape);
                        return [4 /*yield*/, GeoThumbnailWorker_helpers_1.thumbnailStore.getItem(hash)];
                    case 1:
                        svg = _b.sent();
                        if (svg) {
                            this.setState({
                                icon: svg,
                                dangerousIconHtml: {
                                    __html: svg,
                                },
                            });
                        }
                        return [2 /*return*/, svg];
                    case 2:
                        _a = _b.sent();
                        console.error("Error retrieving shape from cache.");
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GKGeoThumbnail.prototype.componentDidMount = function () {
        this.prepareIcon(this.props.id, this.props.shape);
    };
    GKGeoThumbnail.prototype.componentWillUnmount = function () {
        if (this.prepareIconResult) {
            this.prepareIconResult.cancel();
            this.prepareIconResult = null;
        }
    };
    GKGeoThumbnail.prototype.componentDidUpdate = function (prevProps) {
        var shape = this.props.shape;
        var prevShape = prevProps.shape;
        if (shape !== prevShape) {
            this.prepareIcon(this.props.id, this.props.shape);
        }
    };
    GKGeoThumbnail.prototype.render = function () {
        return (React.createElement("div", __assign({ "data-qa": "gk-geo-thumbnail-" + this.props.id, dangerouslySetInnerHTML: this.state.dangerousIconHtml }, this.mappedProps)));
    };
    GKGeoThumbnail.prototype.prepareIcon = function (id, shape) {
        return __awaiter(this, void 0, void 0, function () {
            var cachedShape;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getShapeFromCache()];
                    case 1:
                        cachedShape = _a.sent();
                        if (!cachedShape) {
                            if (this.prepareIconResult) {
                                this.prepareIconResult.cancel();
                                this.prepareIconResult = null;
                            }
                            if (shape) {
                                this.prepareIconResult = services_1.geoThumbnailService.prepareIcon(id, shape);
                                this.prepareIconResult.result.then(this.onIconSuccess, this.onIconError);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return GKGeoThumbnail;
}(common_1.GKPureComponent));
exports.GKGeoThumbnail = GKGeoThumbnail;
